import { partnerClient } from '@modules/core/services';
import { differenceInDays } from 'date-fns';
import { DEFAULT_STUDY_ID, MAX_GROUP_KEY_BY_DAY_DIFFERENCE } from '../constants';
import { GroupKey } from '../types/api';
import { SequencedSamples } from '../types/sequenced-samples.types';
import { FetchSamplesParam } from '@modules/study-insights/types/samples.types';

const getGroupKeyByDates = (
  startDate: Date | string | undefined,
  endDate: Date | string | undefined,
): GroupKey | undefined => {
  if (startDate === undefined || endDate === undefined) {
    return undefined;
  }

  const startDateObj = new Date(startDate);
  const endDateObj = new Date(endDate);
  if (differenceInDays(endDateObj, startDateObj) <= MAX_GROUP_KEY_BY_DAY_DIFFERENCE) {
    return GroupKey.BY_DAY;
  }

  return GroupKey.BY_MONTH;
};

export const fetchSamplesSequenced = async ({
  sampleStatus,
  startDate,
  endDate,
  studyId = DEFAULT_STUDY_ID,
}: FetchSamplesParam): Promise<SequencedSamples | undefined> => {
  const groupKey = getGroupKeyByDates(startDate, endDate);

  const response = await partnerClient.get(`/studies/${studyId}/metrics/samples-sequenced`, {
    params: {
      sampleStatus: sampleStatus.join(','),
      groupKey,
      startDate,
      endDate,
    },
  });

  return response?.data;
};
